import React from "react";
import PageError from "@radarly/components/error-boundary/page";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";

interface ErrorPageLayoutProps {
  url?: string;
}

export default function ErrorPageLayout({ url = "" }: ErrorPageLayoutProps) {
  const locale = useCurrentUserLocale();
  return <PageError locale={locale} url={url} />;
}
